<template>
  <div class="question_content">
    <div class="question_top">
      <p>{{ bookItem.name }}</p>
    </div>
    <div class="question_middle">
      <div v-for="(item, index) in bookItem.catalogList" :key="index" class="middle_item">
        <el-tooltip class="item" effect="light" :content="item.name" placement="top-start">
          <div class="questionName">{{ item.name }}</div>
        </el-tooltip>
        <div class="" style="display: flex;
      align-items: center;
      justify-content: space-around;">
          <div class="button" :class="[item.status == '0' ? 'red' : 'green']" @click="enableCatalog(item.id,item.status)">{{
            item.status == '0' ? '禁用' : '启用' }}</div>
          <div class="button edit" @click="editCatalog(item)">编辑</div>
          <div class="button red" @click="delCatalog(item)">删除</div>
        </div>
      </div>
    </div>
    <div class="question_footer">
      <div class="option">
        <el-dropdown @command="dropCommand">
          <el-button plain class="dropdown_btn">
            <div>
              <img src="../static/ellipsis.png" alt="" />
              操作
            </div>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item style="color: #0094ff;font-size:14rem" command="1">编辑题源</el-dropdown-item>
            <el-dropdown-item style="color: #fe1d1d;font-size:14rem" command="2">禁用题源</el-dropdown-item>
            <el-dropdown-item style="color: #fe1d1d;font-size:14rem" command="3">删除题源</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="guide topic" @click="addCatalog()">
        <img src="../../../assets/images/icon-add.png" alt="" />
        新增模块
      </div>
    </div>

    <!--编辑题源对话框-->
    <el-dialog :visible.sync="questionVisible" width="380rem" class="questionDia">
      <div slot="title">
        <div class="dia-title">
          <div class="dia-title-before"></div>
          <div class="dia-title-text">编辑题源</div>
        </div>
      </div>
      <div class="question-content">
        <span class="red-star-icon">*</span>
        <p>题源：</p>
        <el-input placeholder="请输入题源名称" v-model="questionForm.name"> </el-input>
      </div>
      <div class="question-content">
        <span class="red-star-icon" style="opacity: 0;">*</span>
        <p>备注：</p>
        <el-input placeholder="请简要描述" v-model="questionForm.note"> </el-input>
      </div>
      <div class="question-content">
        <p class="from-item-lable">启用：</p>
        <el-switch v-model="questionForm.status" active-color="#0BAE6A" inactive-color="#eeeeee">
        </el-switch>
      </div>
      <div class="save-button" :class="{ 'diable-btn': qusBtnDisabled }" @click="editQuestion">保存</div>
    </el-dialog>

    <!-- 遮罩层 -->
    <div class="mask" v-if="mask">
      <el-button @click="disableQuestionSource(false)">启用题源</el-button>
      <img class="image" src="../static/forbidden.png" />
    </div>

    <el-empty description=" " :image-size="100" :image="require('../static/empty.png')" v-if="empty"></el-empty>
  </div>
</template>

<script>
import {
  createQuestionOpt,
  updateQuestionStatusOpt,
  updateCatalogStatusOpt,
  deleteBook,
  deleteCatalog
} from "@/api/special";
export default {
  name: "quesiotnItem",
  props: {
    bookItem: {
      type: Object,
      default: () => { }
    },
    region: {
        type:String
    }
  },
  watch: {
    "questionForm.name": {
      handler(val) {
        if (val) {
          this.qusBtnDisabled = false;
        } else {
          this.qusBtnDisabled = true;
        }
      },
      immediate: true,
    },
    bookItem: {
      handler(val) {
        console.log('bookItem===', val);
        this.mask = val.status == "0" ? false : true
        if (val.catalogList.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      },
      deep: true,
      immediate: true,
    }
  },
  data() {
    return {
      mask: false,
      questionVisible: false,
      qusBtnDisabled: true,
      empty: false,
      questionForm: {
        name: "",
        note: "",
        status: true,
      },
    };
  },
  methods: {
    dropCommand(command) {
      if (command == "1") {
        this.getQuestionSource()
      }
      if (command == "2") {
        this.disableQuestionSource(true);
      }
      if (command == "3") {
        this.deleteQuestionSource();
      }
    },
    deleteQuestionSource() {
      this.$confirm("删除后，数据将被清除无法恢复", "是否删除当前题源？", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "customClass_1",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
      })
        .then(() => {
          deleteBook({
            bookId: this.bookItem.id
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除题源成功");
              this.$emit("initAfterEdit");
            } else {
              this.$message.error(res.info);
            }
          });
        })
        .catch(() => { });
    },
    disableQuestionSource(flag) {
      let msg1 = flag
        ? "禁用后，将关闭该题源下模块、单元等各级启用权限"
        : "启用后，还需要打开该题源下模块、单元等各级启用权限";
      let msg2 = flag ? "是否禁用当前题源?" : "是否启用当前题源?";
      this.$confirm(msg1, msg2, {
        distinguishCancelAndClose: true,
        confirmButtonText: flag ? "禁用" : "启用",
        cancelButtonText: "取消",
        customClass: "customClass_1",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
      })
        .then(() => {
          let status = flag ? "1" : "0";
          updateQuestionStatusOpt({
            id: this.bookItem.id,
            status: status,
          }).then((res) => {
            if (res.code == 0) {
              this.mask = flag ? true : false;
              this.$message.success(flag ? "禁用成功" : "启用成功");
              this.$emit("initAfterEdit");
            } else {
              this.$message.error(res.info);
            }
          });
        })
        .catch(() => { });
    },

    getQuestionSource() {
      this.questionVisible = true;
      this.questionForm.name = this.bookItem.name;
      this.questionForm.status = this.bookItem.status == '0' ? true : false
      this.questionForm.note = this.bookItem.note;
    },

    editQuestion() {
      if(this.questionForm.note.length>12){
        this.$message.warning("备注字数不能超过12个");
        return;
      }
      if (!this.qusBtnDisabled) {
        let form = {}
        form.id = this.bookItem.id;
        form.regionId = this.bookItem.regionId
        form.name = this.questionForm.name
        form.note = this.questionForm.note
        form.status = this.questionForm.status ? "0" : "1"
        createQuestionOpt(form).then(res => {
          if (res.code == 0) {
            this.$message.success("编辑成功");
            this.questionVisible = false;
            this.$emit("initAfterEdit");
          } else {
            this.$message.success(res.info);
          }
        })
      }
    },

    enableCatalog(id,status) {
      let msg1 = status == '0' ? '禁用后，将无法显示当前模块' : '启用后，显示当前模块';
      let msg2 = status == '0' ? '禁用当前模块？' : '启用当前模块？';
      this.$confirm(msg1, msg2, {
        distinguishCancelAndClose: true,
        confirmButtonText: status == '0' ? "禁用" : "启用",
        cancelButtonText: "取消",
        customClass: "customClass_1",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
      })
        .then(() => {
          updateCatalogStatusOpt({
            id: id,
            status: status=='0' ? '1':'0',
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success(status == '0'? "禁用成功" : "启用成功");
              this.$emit("initAfterEdit");
            } else {
              this.$message.error(res.info);
            }
          });
        })
        .catch(() => { });
    },
    addCatalog() {
        // console.log(this.bookItem)
        // console.log(item)
        
        let bookId = this.bookItem.id
        // // let type = item.name
        // let catalogId = item.id
        let regionId = this.$parent.specialItem.areaId    //this.bookItem.regionId
        let questionSource = this.bookItem.name

        this.setStoreData(regionId,bookId,'','')
        
        let urlParams = '?bookId=' + bookId + '&region=' + this.region + "&regionId=" + regionId + '&questionSource=' + questionSource +'&type=';
        this.$router.push({
          path: '/special/detail' + urlParams
        })
    },
    editCatalog(item) {
        console.log(this.bookItem)
        console.log(item)
        
        let bookId = item.bookId
        let type = item.name
        let catalogId = item.id
        let regionId = this.$parent.specialItem.areaId //这里应该时areaId，地区的id  而非regionId，与三期保持一致  //this.bookItem.regionId
        let questionSource = this.bookItem.name

        this.setStoreData(regionId,bookId,type,catalogId)
        
        // console.log(this.$parent.specialItem)
        let urlParams = '?bookId=' + bookId + '&region=' + this.region + "&regionId=" + regionId + '&questionSource=' + questionSource + '&type=' + type + '&catalogId=' + catalogId;
        this.$router.push({
          path: '/special/detail' + urlParams
        })
    },
    delCatalog(item){
      console.log(this.$parent.specialItem,item)
      this.$confirm("删除后，数据将被清除无法恢复", "是否删除当前模块？", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "customClass_1",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
      })
        .then(() => {
          deleteCatalog({
            catalogId: item.id
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除模块成功");
              this.$emit("initAfterEdit");
            } else {
              this.$message.error(res.info);
            }
          });
        })
        .catch(() => {});
    },
    setStoreData(regionId,bookId,type,catalogId){
        this.$store.commit('updateRegionId', regionId);
        this.$store.commit('updatebookId', bookId);
        this.$store.commit('updateCatalogType', type);
        this.$store.commit('updateCatalogId', catalogId);
    }
  },
};
</script>

<style lang="scss" scoped>
.btnCancel{
      margin-left: 10rem;
}
.question_content {
  position: relative;
  // width: 242rem;
  width: 363rem;
  height: 380rem;
  background: #fff;
  border-radius: 8rem;
  padding: 20rem;
  box-sizing: border-box;

  .question_top {
    display: flex;
    justify-content: center;

    p {
      font-size: 18rem;
      font-weight: bold;
      border-bottom: 4rem solid var(--primary-color);
      
      overflow: hidden;/*超出部分隐藏*/
      text-overflow:ellipsis;/* 超出部分显示省略号 */
      white-space: nowrap;/*规定段落中的文本不进行换行 */
    }
  }

  .question_middle {
    margin-top: 10rem;
    height: 280rem;
    border-bottom: 2rem solid #E9E9E9;
    overflow: auto;

    .middle_item {
      display: flex;
      align-items: center;
      // justify-content: space-around;
      justify-content: space-between;
      border-radius: 6rem;
      height: 60rem;
      margin-bottom: 8rem;
      background: #F5F5F5FF;
      padding: 0 20rem;

      .questionName{
        white-space: nowrap;      /* 确保文本在一行内显示 */
        overflow: hidden;         /* 超出容器部分隐藏 */
        text-overflow: ellipsis;  /* 使用省略号表示被截断的文本 */

        font-size: 16rem;
        font-weight: bold;
        width: 70rem;
      }

      // div:first-child {
      //   font-size: 16rem;
      //   font-weight: bold;
      //   width: 70rem;
      // }

      .button {
        cursor: pointer;
        text-align: center;
        width: 44rem;
        height: 22rem;
        border-radius: 10rem;
        margin-left: 15rem;
      }

      .green {
        background: #E1FAE8;
        color: #19B372;
      }

      .red {
        // background: #f1c4c2;
        background: #F7E8E8;
        color: #FF0000;
      }

      .edit {
        color: #0094FF;
        // background: #d4e1f8;
        background: #E5F0FF;
      }
    }
  }

  .question_footer {
    display: flex;
    justify-content: space-around;

    .guide {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100rem;
      height: 32rem;
      border-radius: 3rem;
      background: #fff;
      font-size: 14rem;
      cursor: pointer;

      img {
        height: 16rem;
        width: 16rem;
        margin-right: 3rem;
      }
    }

    .option {
      .dropdown_btn {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        height: 32rem;
        font-size: 14rem;
        color: #666666;
        border: none;

        &:hover {
          color: #666666;
        }

        div {
          display: flex;
          align-items: center;

          img {
            height: 16rem;
            width: 16rem;
            margin-right: 3rem;
          }
        }
      }
    }

    .topic {
      color: var(--primary-color);
      border-color: var(--primary-color);
    }
  }

  .questionDia {
    ::v-deep .el-dialog {
      height: 275rem;
    }

    ::v-deep .el-input__inner {
      height: 32rem;
    }

    .question-content {
      display: flex;
      align-items: center;
      margin-bottom: 20rem;

      p {
        width: 50rem;
        font-size: 14rem;
      }
    }

    .save-button {
      position: absolute;
      right: 20rem;
      bottom: 20rem;
      width: 72rem;
      height: 32rem;
      line-height: 32rem;
      font-size: 14rem;
      color: #fff;
      background: var(--primary-color);
      border-radius: 4rem;
      display: flex;
      justify-content: center;
      cursor: pointer;
    }

    .diable-btn {
      background: #b7e7d3;
    }
  }

  .el-empty {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    border-radius: 10rem;
    width: 100%;
    height: 280rem;
    z-index: 0;
  }

  .mask {
    z-index: 30;
    position: absolute;
    border-radius: 10rem;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* 按钮居中 */
    display: flex;
    justify-content: center;
    align-items: center;

    .el-button {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-image: var(--background-image);
      border: none !important;
      border-radius: 6rem;
      box-shadow: none !important;
      font-size: 14rem;
      width: 76rem;
      height: 35rem;
    }

    .image {
      width: 110rem;
      height: 110rem;
      position: absolute;
      top: -26rem;
      right: -26rem;
    }
  }

  ::v-deep .el-dialog__header .el-dialog__close:hover {
    color: var(--primary-color) !important;
  }
}

::-webkit-scrollbar {
  width: 0rem;
}

// ::-webkit-scrollbar-thumb {
//   border-radius: 6rem;
//   background-color: #d9d9d9;
// }
.red-star-icon{
  font-size:14rem;
  color:#FF0000;
  margin-right:5rem;
}
.from-item-lable{
  margin-left: 14rem;
}
</style>